import { Heading } from '@/components/ui/heading';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

type Props = {
  submitting: boolean;
  hasProfile: boolean;
  onStart: () => void;
  onReset: () => void;
};

export function ToneIntro({ submitting, hasProfile, onStart, onReset }: Props) {
  return (
    <div className="p-6 space-y-5 rounded-xl border border-border bg-card shadow-sm">
      <div className="flex items-start gap-3">
        <Badge variant="secondary">Nuovo</Badge>
        <div className="space-y-2">
          <Heading level={2}>Dai la tua voce all’assistente</Heading>
          <p className="text-sm text-muted-foreground">
            In 3 minuti, senza dati reali: rispondi a 3 scenari finti, poi scegli come suoneresti.
            Distilliamo il tuo stile e lo applichiamo alle chat dei tuoi pazienti.
          </p>
          <p className="text-xs text-muted-foreground">
            Nessuna diagnosi, solo tono di voce. Puoi rifarlo quando vuoi.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button disabled={submitting} onClick={onStart}>
          Inizia ora (≈3 minuti)
        </Button>
        {hasProfile ? (
          <Button variant="outline" disabled={submitting} onClick={onReset}>
            Rifai intervista
          </Button>
        ) : null}
      </div>
    </div>
  );
}
